/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Maximum_Gap_AllowedInputs */



/**
* | output |
* | --- |
* | "Maximum gap allowed between frames" |
*
* @param {Maximum_Gap_AllowedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const maximum_gap_allowed = /** @type {((inputs?: Maximum_Gap_AllowedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Maximum_Gap_AllowedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Écart maximum autorisé entre les images")
	if (locale === "de") return /** @type {LocalizedString} */ ("Maximal zulässiger Abstand zwischen den Bildern")
	if (locale === "it") return /** @type {LocalizedString} */ ("Spazio massimo consentito tra i telai")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Максимально допустимый зазор между рамками")
	if (locale === "es") return /** @type {LocalizedString} */ ("Espacio máximo permitido entre marcos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("帧之间允许的最大间距")
	if (locale === "ja") return /** @type {LocalizedString} */ ("フレーム間の最大許容ギャップ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("फ़्रेमों के बीच अधिकतम अनुमत अंतराल")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Espaço máximo permitido entre quadros")
	return /** @type {LocalizedString} */ ("Maximum gap allowed between frames")
});